const DeletedPage = () => 'Page supprimée.';

export const HomePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/HomePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const BuyPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/acheter/BuyPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const AdminHomePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/accueil/AdminHomePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const NewsListPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-actualites/NewsListPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const NewNewsPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-actualites/nouvelle/NewNewsPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const UpdateNewsPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-actualites/[id]/UpdateNewsPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const UsersListPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-utilisateurs/UsersListPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const NewUserPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-utilisateurs/nouvel-utilisateur/NewUserPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const UserPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-utilisateurs/[user_id]/UserPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const BeOsabaPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/beosaba/BeOsabaPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const PropertiesPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/biens/PropertiesPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const PropertyPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/biens/[bien_reference]/PropertyPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const BlogPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/blog/BlogPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const CategoriePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/blog/categories/[categorie]/CategoriePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ArticlePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/blog/[slug]/ArticlePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ContactPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/contact/ContactPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const CreateursPatrimoinePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/createurs-de-patrimoine/CreateursPatrimoinePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ConseilMontagePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/createurs-de-patrimoine/conseil-montage/ConseilMontagePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const DivisionAmenagementPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/createurs-de-patrimoine/division-amenagement/DivisionAmenagementPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const RehabilitationRenovationPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/createurs-de-patrimoine/rehabilitation-renovation/RehabilitationRenovationPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const HonorairesPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/honoraires/HonorairesPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const LoginPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/login/LoginPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const MentionsPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/mentions-legales/MentionsPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const MyAccountPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/mon-compte/MyAccountPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const RequestPasswordPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/mot-de-passe-oublie/RequestPasswordPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const NewPasswordPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/mot-de-passe-oublie/nouveau-mot-de-passe/[token]/NewPasswordPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const OsabaPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/qui-sommes-nous/OsabaPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const RejoindreEquipePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/rejoindre-osaba/RejoindreEquipePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const VendreEstimerPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/vendre-estimer/VendreEstimerPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

const ROUTES = { HomePage, BuyPage, AdminHomePage, NewsListPage, NewNewsPage, UpdateNewsPage, UsersListPage, NewUserPage, UserPage, BeOsabaPage, PropertiesPage, PropertyPage, BlogPage, CategoriePage, ArticlePage, ContactPage, CreateursPatrimoinePage, ConseilMontagePage, DivisionAmenagementPage, RehabilitationRenovationPage, HonorairesPage, LoginPage, MentionsPage, MyAccountPage, RequestPasswordPage, NewPasswordPage, OsabaPage, RejoindreEquipePage, VendreEstimerPage };
export default ROUTES;